import { initialState } from './initialState';

export const state = { ...initialState };
